<template>
  <el-form
    status-icon
    :model="driver"
    :rules="rules"
    label-position="top"
    ref="ruleForm"
    label-width="120px"
    v-loading="loading"
    class="carpo-form demo-ruleForm gap-y-6"
  >
    <el-form-item :label="$t('GENDER')" prop="gender" v-loading="genderLoading">
      <el-select
        :disabled="ruleForm.disabled"
        filterable
        v-model="driver.gender.id"
        :placeholder="$t('SELECT_PLACEHOLDER')"
      >
        <el-option
          v-for="item in genderList"
          :key="item.id"
          :label="$i18n.locale == 'fa' ? item.fa_title : item.en_title"
          :value="item.id"
        >
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item :label="$t('FIRST_NAME')" prop="first_name">
      <el-input
        :disabled="ruleForm.disabled"
        type="text"
        v-model="driver.first_name"
        autocomplete="off"
      ></el-input>
    </el-form-item>
    <el-form-item :label="$t('LAST_NAME')" prop="last_name">
      <el-input
        :disabled="ruleForm.disabled"
        type="text"
        v-model="driver.last_name"
        autocomplete="off"
      ></el-input>
    </el-form-item>

    <el-form-item :label="$t('FATHER_NAME')" prop="father_name">
      <el-input
        :disabled="ruleForm.disabled"
        type="text"
        v-model="driver.father_name"
        autocomplete="off"
      ></el-input>
    </el-form-item>
    <el-form-item :label="$t('BIRTHDAY')" prop="birthdate">
      <date-picker
        :disabled="ruleForm.disabled"
        color="#151515"
        class="el-input__inner"
        v-model="driver.birthdate"
        view="year"
        format="jYYYY-jMM-jDD"
        max="1400/09/09"
        clearable
        :locale="$i18n.locale"
      />
    </el-form-item>
    <el-form-item :label="$t('NATIONAL_CODE')" prop="national_id">
      <el-input
        :disabled="ruleForm.disabled"
        type="text"
        @input="driver.national_id = toEnglish(driver.national_id)"
        v-model="driver.national_id"
        autocomplete="off"
        class="left-inputs"
      ></el-input>
    </el-form-item>

    <el-form-item
      :label="$t('BIRTH_CERTIFICATE')"
      prop="birth_certificate_number"
    >
      <el-input
        :disabled="ruleForm.disabled"
        type="text"
        @input="
          driver.birth_certificate_number = toEnglish(
            driver.birth_certificate_number
          )
        "
        v-model="driver.birth_certificate_number"
        autocomplete="off"
        class="left-inputs"
      ></el-input>
    </el-form-item>

    <el-form-item :label="$t('MOBILE')" prop="mobile">
      <el-input
        :disabled="ruleForm.disabled"
        type="text"
        v-model="driver.mobile"
        autocomplete="off"
        @input="driver.mobile = toEnglish(driver.mobile)"
        class="left-inputs"
      ></el-input>
    </el-form-item>

    <el-form-item prop="email" :label="$t('EMAIL')">
      <el-input :disabled="ruleForm.disabled" v-model="driver.email"></el-input>
    </el-form-item>

    <el-form-item :label="$t('CREDIT_CARD_NUMBER')" prop="credit_card_number">
      <el-input
        :disabled="ruleForm.disabled"
        type="text"
        @input="
          driver.credit_card_number = toEnglish(driver.credit_card_number)
        "
        v-model="driver.credit_card_number"
        autocomplete="off"
        class="left-inputs"
        clearable
      ></el-input>
    </el-form-item>
    <el-form-item
      :label="$t('MARITAL_STATUS')"
      prop="marriage"
      v-loading="maritalLoading"
    >
      <el-select
        :disabled="ruleForm.disabled"
        clearable
        filterable
        v-model="driver.marital_status.id"
        :placeholder="$t('SELECT_PLACEHOLDER')"
      >
        <el-option
          v-for="item in marriageList"
          :key="item.id"
          :label="$i18n.locale == 'fa' ? item.fa_title : item.en_title"
          :value="item.id"
        >
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item :label="$t('NUMBER_OF_CHILDREN')" prop="number_of_children">
      <el-select
        :disabled="ruleForm.disabled"
        clearable
        filterable
        v-model="driver.number_of_children"
        :placeholder="$t('SELECT_PLACEHOLDER')"
      >
        <el-option
          v-for="item in childCount"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </el-form-item>

    <el-form-item
      :label="$t('EDUCATION')"
      prop="education"
      v-loading="educationLoading"
    >
      <el-select
        :disabled="ruleForm.disabled"
        clearable
        filterable
        v-model="driver.education.id"
        :placeholder="$t('SELECT_PLACEHOLDER')"
      >
        <el-option
          v-for="item in educationList"
          :key="item.id"
          :label="$i18n.locale == 'fa' ? item.fa_title : item.en_title"
          :value="item.id"
        >
        </el-option>
      </el-select>
    </el-form-item>

    <el-form-item :label="$t('PROVINCE')" prop="address.province.id">
      <el-select
        :disabled="ruleForm.disabled"
        :placeholder="$t('SELECT_PLACEHOLDER')"
        v-model="driver.address.province.id"
        filterable
        clearable
        @change="provinceChange(driver.address.province.id)"
      >
        <el-option
          v-for="item in provinceList"
          :key="item.id"
          :label="$i18n.locale == 'fa' ? item.fa_title : item.en_title"
          :value="item.id"
        >
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item
      v-loading="cityLoading"
      element-loading-spinner="el-icon-loading"
      :label="$t('CITY')"
      prop="address.city.id"
    >
      <el-select
        :placeholder="$t('SELECT_PLACEHOLDER')"
        v-model="driver.address.city.id"
        filterable
        clearable
        @change="cityChange(driver.address.city.id)"
        :disabled="driver.address.province.id === '' || driver.disabled"
      >
        <el-option
          v-for="item in cityList"
          :key="item.id"
          :label="$i18n.locale == 'fa' ? item.fa_title : item.en_title"
          :value="item.id"
        >
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item
      v-loading="neighborhoodLoading"
      element-loading-spinner="el-icon-loading"
      :label="$t('NEIGHBORHOOD')"
      prop="address.neighborhood.id"
    >
      <el-select
        :placeholder="$t('SELECT_PLACEHOLDER')"
        v-model="driver.address.neighborhood.id"
        @change="neighborhoodChange()"
        filterable
        clearable
        :disabled="driver.address.city.id === '' || driver.disabled"
      >
        <el-option
          v-for="item in neighborhoodList"
          :key="item.id"
          :label="$i18n.locale == 'fa' ? item.fa_title : item.en_title"
          :value="item.id"
        >
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item :label="$t('POSTAL_CODE')" prop="address.postal_code">
      <el-input
        :disabled="ruleForm.disabled"
        type="text"
        @input="
          driver.address.postal_code = toEnglish(driver.address.postal_code)
        "
        v-model="driver.address.postal_code"
        autocomplete="off"
        class="left-inputs"
      ></el-input>
    </el-form-item>

    <el-form-item
      class="lg:col-span-2 xl:col-span-full"
      prop="address.postal_address"
      :label="$t('ADDRESS')"
      :rules="[
        {
          required: false,
          message: $t('REQUIRED_FIELD', { type: $t('ADDRESS') }),
          trigger: 'blur',
        },
      ]"
    >
      <el-input
        :disabled="ruleForm.disabled"
        v-model="driver.address.postal_address"
      ></el-input>
    </el-form-item>

    <el-form-item
      class="col-span-full"
      :label="$t('description')"
      prop="description"
    >
      <el-input
        :disabled="ruleForm.disabled"
        type="textarea"
        v-model="driver.description"
      ></el-input>
    </el-form-item>

    <FormConfirmation
      :loading="submitLoading"
      v-if="!driver.disabled"
      @resetForm="resetForm('ruleForm')"
      @submitForm="submitForm('ruleForm')"
    />
  </el-form>
</template>

<script>
import { resetForm } from "@/mixins/resetForm";
import {
  driverGenders,
  driverEducation,
  driverMartial,
  editDriver,
} from "@/api/drivers";
import { provinceList, cityList, neighborhoodList } from "@/api/global";
import { jalaliToGregorian } from "@/mixins/jalaliToGregorian";
import FormConfirmation from "@/components/elements/formConfirmation.vue";

export default {
  props: ["ruleForm", "loading"],
  mixins: [resetForm, jalaliToGregorian],
  components: {
    FormConfirmation,
  },
  data() {
    var checkpostalcode = (rule, value, callback) => {
      var strongRegex = new RegExp("^[\u06F0-\u06F90-9]{10}$");
      if (value == undefined) callback();

      if (strongRegex.test(value)) {
        callback();
      } else {
        callback(
          new Error(
            this.$i18n.t("INVALID_FIELD", { type: this.$i18n.t("POSTAL_CODE") })
          )
        );
      }
    };
    var checkSelect = (rule, value, callback) => {
      if (value != undefined && !value.length) callback();

      //   if (value != '') {
      //     callback()
      //   } else {
      //     callback(new Error(rule.message))
      //   }
    };
    var checkEmail = (rule, value, callback) => {
      if (value == "") {
        callback();
      }
      if (value != undefined) {
        var strongRegex = new RegExp(
          "^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$"
        );
        if (strongRegex.test(value)) {
          callback();
        } else {
          callback(
            new Error(
              this.$i18n.t("INVALID_FIELD", { type: this.$i18n.t("EMAIL") })
            )
          );
        }
      } else {
        callback();
      }
    };
    var nationalCheck = (rule, value, callback) => {
      var strongRegex = new RegExp("^[\u06F0-\u06F90-9]{10}$");
      //   console.log(!value.length)
      if (value == undefined) callback();
      if (value != undefined && !value.length) callback();

      if (!strongRegex.test(value))
        return callback(
          new Error(
            this.$i18n.t("INVALID_FIELD", {
              type: this.$i18n.t("NATIONAL_CODE"),
            })
          )
        );
      const check = +value[9];
      const sum =
        value
          .split("")
          .slice(0, 9)
          .map((x, i) => +x * (10 - i))
          .reduce((x, y) => x + y) % 11;
      if (sum < 2 ? check == sum : check + sum == 11) {
        callback();
      } else {
        callback(
          new Error(
            this.$i18n.t("INVALID_FIELD", {
              type: this.$i18n.t("NATIONAL_CODE"),
            })
          )
        );
      }
    };
    var checkMobile = (rule, value, callback) => {
      var strongRegex = new RegExp(
        "^(\\+98|0)?9\\d{9}|۰۹[\u06F0-\u06F90-9]{9}$"
      );

      if (value == undefined) callback();
      if (value != undefined && !value.length) callback();

      if (strongRegex.test(value)) {
        callback();
      } else {
        callback(
          new Error(
            this.$i18n.t("INVALID_FIELD", {
              type: this.$i18n.t("MOBILE"),
            })
          )
        );
      }
    };
    var checkBank = (rule, value, callback) => {
      if (value != "" && value != undefined && value != null) {
        if (value != undefined) {
          callback();
        }
        if (value.length !== 16) {
          callback(
            new Error(
              this.$i18n.t("INVALID_FIELD", {
                type: this.$i18n.t("CREDIT_CARD_NUMBER"),
              })
            )
          );
        }
        let cardTotal = 0;
        for (let i = 0; i < 16; i += 1) {
          const c = Number(value[i]);
          if (i % 2 === 0) {
            cardTotal += c * 2 > 9 ? c * 2 - 9 : c * 2;
          } else {
            cardTotal += c;
          }
        }
        if (cardTotal % 10 === 0) {
          callback();
        } else {
          callback(
            new Error(
              this.$i18n.t("INVALID_FIELD", {
                type: this.$i18n.t("CREDIT_CARD_NUMBER"),
              })
            )
          );
        }
      } else {
        callback();
      }
    };
    return {
      date: "",
      active: 0,
      licenseLoading: true,
      genderLoading: true,
      maritalLoading: true,
      educationLoading: true,
      genderList: [],
      marriageList: [],
      educationList: [],
      submitLoading: false,
      countryList: [],
      cityList: [],
      driver: {
        ...this.ruleForm,
        gender: {
          id: "",
        },
        education: {
          id: "",
        },
        marital_status: {
          id: "",
        },
        blood_type: {
          id: "",
        },
        address: {
          postal_address: "",
          postal_code: "",
          province: {
            id: "",
          },
          city: {
            id: "",
          },
          neighborhood: {
            id: "",
          },
        },
      },
      neighborhoodList: [],
      provinceList: [],
      cityLoading: false,
      neighborhoodLoading: false,
      addressId: "",
      childCount: [
        {
          value: 0,
          label: this.$i18n.t("NO_CHILDREN"),
        },
        {
          value: 1,
          label: "۱",
        },
        {
          value: 2,
          label: "۲",
        },
        {
          value: 3,
          label: "۳",
        },
        {
          value: 4,
          label: this.$i18n.t("MORE_THAN_THREE"),
        },
      ],

      rules: {
        gender: [
          {
            required: false,
            trigger: "blur",
            message: this.$i18n.t("REQUIRED_CHOOSE", {
              type: this.$i18n.t("GENDER"),
            }),
          },
        ],
        first_name: [
          {
            required: true,
            message: this.$i18n.t("REQUIRED_FIELD", {
              type: this.$i18n.t("FIRST_NAME"),
            }),
            trigger: "blur",
          },
        ],
        last_name: [
          {
            required: true,
            message: this.$i18n.t("REQUIRED_FIELD", {
              type: this.$i18n.t("LAST_NAME"),
            }),
            trigger: "blur",
          },
        ],
        father_name: [
          {
            required: false,
            message: this.$i18n.t("REQUIRED_FIELD", {
              type: this.$i18n.t("FATHER_NAME"),
            }),
            trigger: "blur",
          },
        ],
        birthdate: [
          {
            required: false,
            message: this.$i18n.t("REQUIRED_CHOOSE", {
              type: this.$i18n.t("BIRTHDAY"),
            }),
            trigger: "blur",
          },
        ],
        national_id: [
          {
            required: false,
            trigger: "blur",
            validator: nationalCheck,
          },
        ],
        email: [
          {
            required: false,
            trigger: "blur",
            validator: checkEmail,
          },
        ],
        address: {
          // postal_code: [
          //   {
          //     required: false,
          //     trigger: 'blur',
          //     validator: checkpostalcode,
          //   },
          // ],
          neighborhood: {
            id: [
              {
                required: false,
                validator: checkSelect,
                trigger: "change",
                message: this.$i18n.t("REQUIRED_CHOOSE", {
                  type: this.$i18n.t("NEIGHBORHOOD"),
                }),
              },
            ],
          },
          city: {
            id: [
              {
                required: false,
                validator: checkSelect,
                trigger: "change",
                message: this.$i18n.t("REQUIRED_CHOOSE", {
                  type: this.$i18n.t("CITY"),
                }),
              },
            ],
          },
          province: {
            id: [
              {
                required: false,
                validator: checkSelect,
                trigger: "change",
                message: this.$i18n.t("REQUIRED_CHOOSE", {
                  type: this.$i18n.t("PROVINCE"),
                }),
              },
            ],
          },
        },

        mobile: [
          {
            required: false,
            trigger: "blur",
            validator: checkMobile,
          },
        ],

        credit_card_number: [
          {
            required: false,
            trigger: "blur",
            validator: checkBank,
          },
        ],
      },
    };
  },
  methods: {
    submitForm(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          const actionPayload = {
            first_name: this.driver.first_name,
            last_name: this.driver.last_name,
            birthdate: this.jalaliToGregorian(
              this.driver.birthdate,
              this.$i18n.locale
            ),
            gender: this.driver.gender.id,
            father_name: this.driver.father_name,
            number_of_children: this.driver.number_of_children,
            national_id: this.driver.national_id,
            birth_certificate_number: this.driver.birth_certificate_number,
            marital_status: this.driver.marital_status.id,
            mobile: this.driver.mobile.substring(1),
            address: {
              postal_code: this.driver.address.postal_code,
              postal_address: this.driver.address.postal_address,
              province: this.driver.address.province.id,
              city: this.driver.address.city.id,
              country: 1,
              id: this.ruleForm.address ? this.ruleForm.address.id : "",
              neighborhood: this.driver.address.neighborhood.id,
            },
            education: this.driver.education.id,
            credit_card_number: this.driver.credit_card_number,
            description: this.driver.description,
            id: this.driver.id,
            driver: this.driver.id,
            email: this.driver.email,
          };
          this.submitLoading = true;
          editDriver.api(actionPayload).then((res) => {
            this.submitLoading = false;
            if (res) {
              this.$emit("ruleForm", this.driver);
              this.$notify.success({
                title: this.$t("BASIC_INFO") + " " + this.$t("SUCCESSFULLY_"),
                duration: 5000,
                customClass: "succ_msg",
              });
            }
          });
        } else {
          this.$notify.error({
            title: this.$i18n.t("FIXED_ERRORS", {
              type: this.$i18n.t(this.$route.name),
            }),
            duration: 5000,
            customClass: "error_msg",
          });
          return false;
        }
      });
    },
    provinceChange(el) {
      this.driver.address.city.id = "";
      this.driver.address.neighborhood.id = "";
      this.cityLoading = true;
      if (el) {
        cityList.api(el).then((res) => {
          if (res) {
            this.cityList = res;
            this.cityLoading = false;
          }
        });
      }
    },
    cityChange(el) {
      this.driver.address.neighborhood.id = "";
      this.neighborhoodLoading = true;
      if (el) {
        neighborhoodList.api(el).then((res) => {
          if (res) {
            this.neighborhoodList = res;
            this.neighborhoodLoading = false;
          }
        });
      }
    },
    neighborhoodChange() {
      return;
    },
  },
  mounted() {
    if (this.ruleForm.address == null) {
      this.driver = {
        ...this.ruleForm,
        gender: {
          id: "",
        },
        education: {
          id: "",
        },
        marital_status: {
          id: "",
        },
        blood_type: {
          id: "",
        },
        address: {
          postal_address: "",
          postal_code: "",
          province: {
            id: "",
          },
          city: {
            id: "",
          },
          neighborhood: {
            id: "",
          },
        },
      };
    } else if (this.ruleForm.gender == null) {
      this.driver.gender = {
        id: "",
      };
    } else if (this.ruleForm.marital_status == null) {
      this.driver.marital_status = {
        id: "",
      };
    } else if (this.ruleForm.education == null) {
      this.driver.education = {
        id: "",
      };
    } else if (this.ruleForm.address.province == null) {
      this.driver = {
        ...this.ruleForm,

        address: {
          postal_address: "",
          postal_code: "",
          province: {
            id: "",
          },
          city: {
            id: "",
          },
          neighborhood: {
            id: "",
          },
        },
      };
    } else {
      // Create a copy of the form data to manipulate
      const formattedDriverData = { ...this.ruleForm };

      // Format address objects to ensure they have id structure
      if (formattedDriverData.address) {
        if (formattedDriverData.address.neighborhood === null) {
          formattedDriverData.address.neighborhood = {
            id: "",
          };
        }
      }

      this.driver = formattedDriverData;
    }
    provinceList.api().then((res) => {
      if (res) {
        this.provinceList = res;
      }
    });

    if (this.driver.address.city.id != "") {
      this.cityLoading = true;

      this.neighborhoodLoading = true;
      cityList.api(this.driver.address.province.id).then((res) => {
        if (res) {
          this.cityList = res;
          this.cityLoading = false;
        }
      });
      neighborhoodList.api(this.driver.address.city.id).then((res) => {
        if (res) {
          this.neighborhoodList = res;
          this.neighborhoodLoading = false;
        }
      });
    }

    driverGenders.api().then((res) => {
      if (res) {
        this.genderList = res;
        this.genderLoading = false;
      }
    });
    driverEducation.api().then((res) => {
      if (res) {
        this.educationList = res;
        this.educationLoading = false;
      }
    });
    driverMartial.api().then((res) => {
      if (res) {
        this.marriageList = res;
        this.maritalLoading = false;
      }
    });
  },
  watch: {
    ruleForm(val) {
      this.driver = {
        ...val,
        gender: { id: val.gender ? val.gender.id : "" },
        // education: { id: val.education ? education.id : '' },
        // marital_status: { id: val.marital_status ? marital_status.id : '' },
        // blood_type: { id: val.blood_type ? blood_type.id : '' },
        address: {
          postal_address: val.address ? val.address.postal_address : "",
          postal_code: val.address ? val.address.postal_code : "",
          id: val.address ? val.address.id : "",
          province: { id: val.address.province ? val.address.province.id : "" },
          city: { id: val.address.city ? val.address.city.id : "" },
          neighborhood: {
            id: val.address.neighborhood ? val.address.neighborhood.id : "",
          },
        },
      };

      if (val.address != null && val.address.city) {
        this.cityLoading = true;
        this.neighborhoodLoading = true;
        cityList.api(val.address.province.id).then((res) => {
          if (res) {
            this.cityList = res;
            this.cityLoading = false;
          }
        });
        neighborhoodList.api(val.address.city.id).then((res) => {
          if (res) {
            this.neighborhoodList = res;
            this.neighborhoodLoading = false;
          }
        });
      }
    },
  },
};
</script>
